import React from 'react';

import LogoIbidem from '../../svg/ibidem'

const NewFooter = ({ className }) => (
  <footer className={className}>
  <div className="container mx-auto text-gray-800 border-t border-criptoOrange-600 py-2">
    <div className="text-gray-700 hover:text-criptoBlue-600 cursor-pointer w-auto px-1" style={{transition: 'all .3s ease-in-out'}}>
      <a href="https://www.ibidem.org.br" target="_blank"><LogoIbidem className="w-48" /></a>
    </div>
   
    </div>
  </footer>
);

export default NewFooter;
